var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.974,
    height: 76.834,
    viewBox: "0 0 81.974 76.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_336",
    "data-name": "Rectangle 336",
    width: 81.974,
    height: 76.834,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M40.826,0,0,22.744v9.579L40.826,9.593Z",
    fill: "#404042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 3.941,
    height: 5.577,
    transform: "translate(36.364 22.937)",
    fill: "#404042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    width: 3.941,
    height: 5.577,
    transform: "translate(41.999 22.937)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M220.05,101.6h3.941V96.3a4.108,4.108,0,0,0-3.941,3.966Z",
    transform: "translate(-183.686 -80.386)",
    fill: "#404042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M258.091,101.6H254.15V96.3a4.108,4.108,0,0,1,3.941,3.966Z",
    transform: "translate(-212.151 -80.386)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M288.2,31.827,247.05,9.593V0l19.136,10.411V5.354l7.139-1.884V14.281L288.2,22.343Z",
    transform: "translate(-206.224 0)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M281.74,183.844l-.292-23.86,6.956-3.562-8.164-4.431-19.3,9.956v8.534l11.587-6.027v24.183l-11.587,6.024v8.543l31.615-16.443v-8.543Z",
    transform: "translate(-217.815 -126.875)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M94.178,170.693V158.022l-18.653-9.963L65.25,153.679v13.374l9.558,5.406h0l13.248,7.455-.026,9.514-15.942-9.023v-4.664l-6.838-3.867v12.265l28.928,16.286V175.646L72.091,163.078v-7.659l16.063,8.569v3.286Z",
    transform: "translate(-54.467 -123.591)",
    fill: "#404042"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3e5e0f265a5aaa2b50e62711bb8715b6.svg";
export { ForwardRef as ReactComponent };